import { daysPlus } from '@/functions/general.js';

export default {
  data() {
    return {
			due_date_status_color:{
				'-':'grey',
				'Caducado': 'red',
				'Menos de 1 mes': 'yellow',
				'Menos de 3 meses': 'yellow',
				'Vigente': 'green',
			},
    };
	},
  methods: {
		due_date_status(item){
			if (!item.due_date) return '-';
			const due_date = new Date(item.due_date);
			const now = new Date();
			if (due_date < now) return 'Caducado';
			if (due_date < daysPlus(now,30)) return 'Menos de 1 mes';
			return due_date < daysPlus(now,90)? 'Menos de 3 meses': 'Vigente';
		},
  },
};
